/**
 * Mejora del widget SPD Split Payment (clases spp2__*).
 * Subtítulos, sincronización de campos ocultos al form de add to cart,
 * aplicación del código de descuento y coordinación con el redirect al checkout.
 */
(function () {
  const SUBTITLES_BY_INPUT_ID = {
    'spp2-full-payment-option': 'Accede al curso completo con un solo pago.',
    'spp2-installment-payment-option': 'Financia tu curso en 9 plazos.',
  };

  const SUBTITLES_BY_VALUE = {
    '0': SUBTITLES_BY_INPUT_ID['spp2-full-payment-option'],
    '1': SUBTITLES_BY_INPUT_ID['spp2-installment-payment-option'],
  };

  const WIDGET_SELECTOR = '.spp2__widget_installment:not([data-offsider-selling-plan-widget])';
  const INSTALLMENT_INPUT_SELECTOR = `${WIDGET_SELECTOR} input[name="payment-option"][value="1"]`;
  const SPD_SYNC_ATTR = 'data-offsider-spd-field';

  let enhanceScheduled = false;

  /**
   * @returns {HTMLFormElement | null}
   */
  function getProductAddToCartForm() {
    const form = document.querySelector('product-form-component form[data-type="add-to-cart-form"]');
    return form instanceof HTMLFormElement ? form : null;
  }

  /**
   * @returns {HTMLElement | null}
   */
  function getWidgetScope() {
    const widget = document.querySelector(WIDGET_SELECTOR);
    if (!(widget instanceof HTMLElement)) {
      return null;
    }

    return (
      widget.closest('.product-details') ||
      widget.closest('.shopify-section') ||
      widget.parentElement
    );
  }

  /**
   * @param {string} name
   * @returns {boolean}
   */
  function isSpdRelevantFieldName(name) {
    const normalized = name.toLowerCase();

    return (
      normalized.startsWith('properties[') ||
      normalized.includes('discount') ||
      normalized.includes('split') ||
      normalized.includes('spd') ||
      normalized.includes('installment') ||
      normalized.includes('coupon') ||
      normalized.includes('code')
    );
  }

  /**
   * @returns {boolean}
   */
  function isInstallmentPaymentSelected() {
    const selected = document.querySelector(`${WIDGET_SELECTOR} input[name="payment-option"]:checked`);
    return selected instanceof HTMLInputElement && selected.value === '1';
  }

  /**
   * SPD escucha `click` nativo (event.isTrusted), no `change` sintético.
   *
   * @param {HTMLInputElement} input
   */
  function activatePaymentOption(input) {
    if (!input.checked) {
      input.click();
      return;
    }

    input.dispatchEvent(new Event('change', { bubbles: true }));
  }

  /**
   * Copia al formulario de add to cart todos los hidden fields que SPD inyecta al elegir cuotas.
   */
  function syncSpdFieldsToBuyForm() {
    const productForm = getProductAddToCartForm();
    const widget = document.querySelector(WIDGET_SELECTOR);
    const scope = getWidgetScope();

    if (!productForm || !(widget instanceof HTMLElement) || !scope) {
      return;
    }

    for (const existing of productForm.querySelectorAll(`[${SPD_SYNC_ATTR}]`)) {
      existing.remove();
    }

    const selected = widget.querySelector('input[name="payment-option"]:checked');
    if (!(selected instanceof HTMLInputElement) || selected.value !== '1') {
      return;
    }

    for (const input of scope.querySelectorAll('input[type="hidden"]')) {
      if (!(input instanceof HTMLInputElement)) {
        continue;
      }

      if (input.closest('form[data-type="add-to-cart-form"]')) {
        continue;
      }

      if (!input.name || !isSpdRelevantFieldName(input.name)) {
        continue;
      }

      const clone = input.cloneNode(true);
      if (clone instanceof HTMLInputElement) {
        clone.setAttribute(SPD_SYNC_ATTR, 'true');
        productForm.appendChild(clone);
      }
    }
  }

  /**
   * @returns {string | null}
   */
  function getInstallmentDiscountCode() {
    const widget = document.querySelector(WIDGET_SELECTOR);
    if (!(widget instanceof HTMLElement)) {
      return null;
    }

    const dataCode =
      widget.dataset.discountCode ||
      widget.dataset.discount ||
      widget.getAttribute('data-discount-code');

    if (dataCode) {
      return dataCode;
    }

    const scope = getWidgetScope();
    if (!scope) {
      return null;
    }

    for (const input of scope.querySelectorAll('input[type="hidden"]')) {
      if (!(input instanceof HTMLInputElement) || !input.value) {
        continue;
      }

      const name = input.name.toLowerCase();
      if (name.includes('discount') || name.includes('coupon') || name.includes('code')) {
        return input.value;
      }
    }

    return null;
  }

  /**
   * Antes del add to cart / checkout, re-sincroniza la opción y los campos de SPD.
   */
  function prepareSpdBeforeAddToCart() {
    const widget = document.querySelector(WIDGET_SELECTOR);
    if (!(widget instanceof HTMLElement)) {
      return;
    }

    const selected = widget.querySelector('input[name="payment-option"]:checked');
    if (selected instanceof HTMLInputElement) {
      activatePaymentOption(selected);
    }

    syncSpdFieldsToBuyForm();
  }

  /**
   * @param {string} selector
   * @param {number} timeoutMs
   * @returns {Promise<Element | null>}
   */
  function waitForElement(selector, timeoutMs) {
    return new Promise((resolve) => {
      const existing = document.querySelector(selector);
      if (existing) {
        resolve(existing);
        return;
      }

      const observer = new MutationObserver(() => {
        const found = document.querySelector(selector);
        if (found) {
          observer.disconnect();
          clearTimeout(timeoutId);
          resolve(found);
        }
      });

      const timeoutId = window.setTimeout(() => {
        observer.disconnect();
        resolve(document.querySelector(selector));
      }, timeoutMs);

      observer.observe(document.documentElement, {
        childList: true,
        subtree: true,
      });
    });
  }

  /**
   * @returns {Promise<void>}
   */
  async function ensureInstallmentReady() {
    if (!isInstallmentPaymentSelected()) {
      return;
    }

    const installmentInput = document.querySelector(INSTALLMENT_INPUT_SELECTOR);
    if (!(installmentInput instanceof HTMLInputElement)) {
      return;
    }

    activatePaymentOption(installmentInput);
    await waitForElement('input.spp2__purchase-option-id-installment', 3000);
    syncSpdFieldsToBuyForm();
  }

  const SPD_CART_MUTATE_MAX_MS = 1200;
  const SPD_CART_PROPERTY_MAX_MS = 800;
  const SPD_CART_PROPERTY_POLL_MS = 80;

  /**
   * Registrar ANTES del fetch a cart/add.js para no perder spp-cart:mutate.
   *
   * @returns {Promise<void>}
   */
  function beginSpdCartWait() {
    return new Promise((resolve) => {
      let settled = false;

      const finish = () => {
        if (settled) {
          return;
        }
        settled = true;
        document.removeEventListener('spp-cart:mutate', onMutate);
        window.clearTimeout(timeoutId);
        resolve();
      };

      const onMutate = () => finish();
      const timeoutId = window.setTimeout(finish, SPD_CART_MUTATE_MAX_MS);

      document.addEventListener('spp-cart:mutate', onMutate, { once: true });
    });
  }

  /**
   * @param {number} [maxMs]
   * @returns {Promise<void>}
   */
  function waitForSpdCartProcessing(maxMs = SPD_CART_MUTATE_MAX_MS) {
    return new Promise((resolve) => {
      let settled = false;

      const finish = () => {
        if (settled) {
          return;
        }
        settled = true;
        document.removeEventListener('spp-cart:mutate', onMutate);
        window.clearTimeout(timeoutId);
        resolve();
      };

      const onMutate = () => finish();
      const timeoutId = window.setTimeout(finish, maxMs);

      document.addEventListener('spp-cart:mutate', onMutate, { once: true });
    });
  }

  /**
   * @param {number} [maxMs]
   * @returns {Promise<boolean>}
   */
  async function ensureCartHasInstallmentProperty(maxMs = SPD_CART_PROPERTY_MAX_MS) {
    if (!isInstallmentPaymentSelected()) {
      return true;
    }

    const deadline = Date.now() + maxMs;

    while (Date.now() < deadline) {
      try {
        const response = await fetch('/cart.js', { credentials: 'same-origin' });
        const cart = await response.json();
        const hasInstallmentLine = cart.items?.some(
          (/** @type {{ properties?: Record<string, string> }} */ item) => {
            return Boolean(item.properties?.['_purchase_option_id']);
          }
        );

        if (hasInstallmentLine) {
          return true;
        }
      } catch (error) {
        console.error('Failed to verify SPD installment cart line:', error);
      }

      await new Promise((resolve) => {
        window.setTimeout(resolve, SPD_CART_PROPERTY_POLL_MS);
      });
    }

    return false;
  }

  /**
   * Tras add to cart, espera breve a SPD antes de ir al carrito.
   *
   * @param {Promise<void> | null | undefined} pendingCartWait
   * @returns {Promise<void>}
   */
  async function finishCartRedirectWait(pendingCartWait) {
    if (!isInstallmentPaymentSelected()) {
      return;
    }

    if (pendingCartWait) {
      await pendingCartWait;
    } else {
      await waitForSpdCartProcessing();
    }

    await ensureCartHasInstallmentProperty();
  }

  /**
   * @returns {Promise<string | null>}
   */
  async function waitForInstallmentDiscountCode() {
    if (!isInstallmentPaymentSelected()) {
      return null;
    }

    const deadline = Date.now() + 6000;

    while (Date.now() < deadline) {
      const domCode = getInstallmentDiscountCode();
      if (domCode) {
        return domCode;
      }

      try {
        const response = await fetch('/cart.js', { credentials: 'same-origin' });
        const cart = await response.json();
        const applicableCode = cart.discount_codes?.find(
          (/** @type {{ code: string; applicable: boolean }} */ entry) => entry.applicable
        );

        if (applicableCode?.code) {
          return applicableCode.code;
        }
      } catch (error) {
        console.error('Failed to read cart discount codes:', error);
      }

      await new Promise((resolve) => {
        window.setTimeout(resolve, 200);
      });
    }

    return getInstallmentDiscountCode();
  }

  /**
   * Aplica el código de descuento que SPD genera para el pago en cuotas.
   *
   * @returns {Promise<boolean>}
   */
  async function applyInstallmentDiscount() {
    if (!isInstallmentPaymentSelected()) {
      return false;
    }

    prepareSpdBeforeAddToCart();

    const discountCode = await waitForInstallmentDiscountCode();
    if (!discountCode) {
      return false;
    }

    try {
      await fetch(`/discount/${encodeURIComponent(discountCode)}`, {
        method: 'GET',
        credentials: 'same-origin',
      });
    } catch (error) {
      console.error('Failed to apply installment discount via /discount/:', error);

      try {
        await fetch(Theme.routes?.cart_update_url || '/cart/update.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
          body: JSON.stringify({ discount: discountCode }),
        });
      } catch (fallbackError) {
        console.error('Failed to apply installment discount via cart/update.js:', fallbackError);
        return false;
      }
    }

    await new Promise((resolve) => {
      window.setTimeout(resolve, 200);
    });

    return true;
  }

  /**
   * Flujo completo tras add to cart: esperar SPD → aplicar descuento.
   *
   * @returns {Promise<void>}
   */
  async function completeInstallmentCheckoutPrep() {
    if (!isInstallmentPaymentSelected()) {
      return;
    }

    prepareSpdBeforeAddToCart();
    await waitForSpdCartProcessing();
    await ensureCartHasInstallmentProperty();
    await applyInstallmentDiscount();
  }

  window.OffsiderSpdSplitPayment = {
    applyInstallmentDiscount,
    beginSpdCartWait,
    completeInstallmentCheckoutPrep,
    ensureCartHasInstallmentProperty,
    ensureInstallmentReady,
    finishCartRedirectWait,
    getInstallmentDiscountCode,
    isInstallmentPaymentSelected,
    prepareSpdBeforeAddToCart,
    syncSpdFieldsToBuyForm,
    waitForSpdCartProcessing,
  };

  /**
   * @param {HTMLElement} widget
   */
  function enhanceWidget(widget) {
    for (const option of widget.querySelectorAll('.spp2__widget-option')) {
      const input = option.querySelector('input[type="radio"]');
      const content = option.querySelector('.spp2__payment-option-content');
      const label = content?.querySelector('.spp2__payment-option-label');
      const radio = content?.querySelector('.spp2__radio');

      if (!(input instanceof HTMLInputElement) || !content || !label || !radio) {
        continue;
      }

      let copy = content.querySelector('.spp2__payment-option-copy');

      if (!copy) {
        copy = document.createElement('div');
        copy.className = 'spp2__payment-option-copy';
        content.insertBefore(copy, radio);
        copy.appendChild(label);
      } else if (!copy.contains(label)) {
        copy.appendChild(label);
      }

      const subtitleText =
        SUBTITLES_BY_INPUT_ID[input.id] ?? SUBTITLES_BY_VALUE[input.value] ?? null;

      if (subtitleText && !copy.querySelector('.spp2__payment-option-subtitle')) {
        const subtitle = document.createElement('p');
        subtitle.className = 'spp2__payment-option-subtitle';
        subtitle.textContent = subtitleText;
        copy.appendChild(subtitle);
      }

      bindPaymentOptionRow(content, input, label);
    }
  }

  /**
   * @param {HTMLElement} content
   * @param {HTMLInputElement} input
   * @param {HTMLElement} label
   */
  function bindPaymentOptionRow(content, input, label) {
    if (content.dataset.spp2ClickBound === 'true') {
      return;
    }

    content.dataset.spp2ClickBound = 'true';

    content.addEventListener('click', (event) => {
      if (event.target === input) {
        return;
      }

      if (label.contains(/** @type {Node} */ (event.target))) {
        return;
      }

      activatePaymentOption(input);
      syncSpdFieldsToBuyForm();
    });
  }

  function scanWidgets() {
    for (const widget of document.querySelectorAll(WIDGET_SELECTOR)) {
      if (widget instanceof HTMLElement) {
        enhanceWidget(widget);
      }
    }
  }

  function scheduleEnhanceWidgets() {
    if (enhanceScheduled) {
      return;
    }

    enhanceScheduled = true;
    window.requestAnimationFrame(() => {
      enhanceScheduled = false;
      scanWidgets();
    });
  }

  function bindSpdIntegration() {
    document.addEventListener(
      'change',
      (event) => {
        const target = event.target;
        if (!(target instanceof HTMLInputElement)) {
          return;
        }

        if (target.name !== 'payment-option' || !target.closest(WIDGET_SELECTOR)) {
          return;
        }

        window.requestAnimationFrame(() => {
          syncSpdFieldsToBuyForm();
        });
      },
      true
    );

    document.addEventListener(
      'submit',
      (event) => {
        const form = event.target;
        if (!(form instanceof HTMLFormElement)) {
          return;
        }

        if (form.getAttribute('data-type') !== 'add-to-cart-form') {
          return;
        }

        prepareSpdBeforeAddToCart();
      },
      true
    );

    document.addEventListener(
      'click',
      (event) => {
        const target = event.target;
        if (!(target instanceof Element)) {
          return;
        }

        const button = target.closest(
          'product-form-component button[type="submit"], product-form-component add-to-cart-component button'
        );

        if (!button) {
          return;
        }

        prepareSpdBeforeAddToCart();
      },
      true
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scanWidgets, { once: true });
  } else {
    scanWidgets();
  }

  bindSpdIntegration();

  const observer = new MutationObserver(() => {
    scheduleEnhanceWidgets();
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true,
  });
})();
